import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import { DemoPersonaProvider } from './context/DemoPersonaContext';
import { setReturnTo } from './lib/postLoginRedirect';

const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

const root = ReactDOM.createRoot(document.getElementById('root'));

if (!domain || !clientId) {
  root.render(
    <div style={{ padding: 24, fontFamily: 'system-ui' }}>
      <h1>Missing Auth0 configuration</h1>
      <p>
        Set <code>REACT_APP_AUTH0_DOMAIN</code> and <code>REACT_APP_AUTH0_CLIENT_ID</code> in{' '}
        <code>client/.env</code>, then restart the dev server.
      </p>
    </div>
  );
} else {
  // Callback must match an Allowed Callback URL in Auth0 (include /auth, not only origin).
  const redirectUri = `${window.location.origin}/auth`;

  root.render(
    <React.StrictMode>
      <Auth0Provider
        domain={domain}
        clientId={clientId}
        authorizationParams={{
          redirect_uri: redirectUri,
          ...(audience ? { audience } : {}),
        }}
        cacheLocation="localstorage"
        onRedirectCallback={(appState) => {
          const rt = appState && typeof appState.returnTo === 'string' ? appState.returnTo : '';
          if (rt) setReturnTo(rt);
        }}
      >
        <AuthProvider>
          <DemoPersonaProvider>
            <App />
          </DemoPersonaProvider>
        </AuthProvider>
      </Auth0Provider>
    </React.StrictMode>
  );
}

reportWebVitals();
